import { _range } from '@naturalcycles/js-lib'
import { ReactNode } from 'react'
import styles from './Rating.module.scss'

interface RatingProps {
  reviews?: string

  appDistributor?: 'App Store' | 'Google Play'
}

export function Rating({ reviews = '', appDistributor = 'App Store' }: RatingProps): ReactNode {
  const defaultText =
    appDistributor === 'App Store' ? '57K+ ratings in the App store' : '18K+ Google Play ratings'
  const stars = appDistributor === 'App Store' ? '4.8' : '4.6'

  return (
    <div className={styles.Rating}>
      <div className={styles.Rating__container}>
        <p className={styles.Rating__rating}>{stars}</p>
        <div aria-label="5 stars" className={styles.Rating__stars}>
          {_range(5).map(i => {
            return <img key={i} alt="star" aria-hidden="true" src="/icons/small-star.svg" />
          })}
        </div>
      </div>
      <p className={styles.Rating__text}>{reviews || defaultText}</p>
    </div>
  )
}
